/** Колір крапки заперечення за ризиком (прототип v4 RC): високий — червоний, середній — бурштиновий, низький — сірий. */
export const RISK_COLOR: Readonly<Record<string, string>> = { High: '#b42318', Medium: '#b7791f', Low: '#64748b' };
